import Axios, { AxiosError } from 'axios';
import { ApiBaseUrl } from '../configuration';
import { IFetchResponse } from '../types/IFetchResponse';

export abstract class BaseService {
    protected static axios = Axios.create({
        baseURL: ApiBaseUrl,
        headers: {
            'Content-Type': 'application/json'
        }
    });


    static async findByName<TEntity>(apiEndpoint: string, searchString: string, exactMatch: string, pageNo?: string, resultsPerPage?: string): Promise<IFetchResponse<TEntity>> {
        const queryUrl = ApiBaseUrl + apiEndpoint
        //const queryString = apiEndpoint + "?searchType=" + searchType + "&searchString=" + searchString;
        try {
            let response = await this.axios.get<TEntity>(queryUrl, {params: {searchString: searchString, exactMatch: exactMatch, pageNo: pageNo, resultsPerPage: resultsPerPage}});
            return {
                ok: response.status <= 299,
                statusCode: response.status,
                data: response.data
            };    
        }
        catch (err) {
            let error = err as AxiosError;
            return {
                ok: false,
                statusCode: error.response?.status ?? 500
                //messages: (error.response?.data as IMessages).messages,
            }
        }

    }

    static async findByCode<TEntity>(apiEndpoint: string, hnr: string, snr: string, lbn: string, pageNo?: string, resultsPerPage?: string): Promise<IFetchResponse<TEntity>> {
        const queryUrl = ApiBaseUrl + apiEndpoint
        //const queryString = apiEndpoint + "?searchType=" + searchType + "&searchString=" + searchString;
        try {
            let response = await this.axios.get<TEntity>(queryUrl, {params: {hnr: hnr, snr: snr, lbn: lbn, pageNo: pageNo, resultsPerPage: resultsPerPage}});
            return {
                ok: response.status <= 299,
                statusCode: response.status,
                data: response.data
            };    
        }
        catch (err) {
            let error = err as AxiosError;
            return {
                ok: false,
                statusCode: error.response?.status ?? 500,
                //messages: (error.response?.data as IMessages).messages,
            }
        }

    }

    static async findByCoords<TEntity>(apiEndpoint: string, xCoord: string, yCoord: string, radius: string, pageNo?: string, resultsPerPage?: string): Promise<IFetchResponse<TEntity>> {
        const queryUrl = ApiBaseUrl + apiEndpoint

        try {
            let response = await this.axios.get<TEntity>(queryUrl, {params: {xCoord: xCoord, yCoord: yCoord, radius: radius, pageNo: pageNo, resultsPerPage: resultsPerPage}});
            return {
                ok: response.status <= 299,
                statusCode: response.status,
                data: response.data
            };    
        }
        catch (err) {
            let error = err as AxiosError;
            return {
                ok: false,
                statusCode: error.response?.status ?? 500,
                //messages: (error.response?.data as IMessages).messages,
            }
        }

    }


    static async findByRefNrId<TEntity>(apiEndpoint: string): Promise<IFetchResponse<TEntity>> {
        const queryUrl = ApiBaseUrl + apiEndpoint;

        try {
            let response = await this.axios.get<TEntity>(queryUrl);
            return {
                ok: response.status <= 299,
                statusCode: response.status,
                data: response.data
            };    
        }
        catch (err) {
            let error = err as AxiosError;
            return {
                ok: false,
                statusCode: error.response?.status ?? 500,
                //messages: (error.response?.data as IMessages).messages,
            }
        }

    }


    static async findBySettlement<TEntity>(apiEndpoint: string, searchString: string, pageNo?: string, resultsPerPage?: string): Promise<IFetchResponse<TEntity>> {
        const queryUrl = ApiBaseUrl + apiEndpoint
        //const queryString = apiEndpoint + "?searchType=" + searchType + "&searchString=" + searchString;
        try {
            let response = await this.axios.get<TEntity>(queryUrl, {params: {searchString: searchString, pageNo: pageNo, resultsPerPage: resultsPerPage}});
            return {
                ok: response.status <= 299,
                statusCode: response.status,
                data: response.data
            };    
        }
        catch (err) {
            let error = err as AxiosError;
            return {
                ok: false,
                statusCode: error.response?.status ?? 500,
                //messages: (error.response?.data as IMessages).messages,
            }
        }

    }


}